export default __webpack_public_path__ + "static/media/banner.b7a0ee2d.webp";